var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"l-content"},[(_vm.dataList)?_c('el-card',[_c('l-table',{attrs:{"option":_vm.tableOption,"data":_vm.dataList}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }